__turbopack_context__.v({
  "arrow": "styles-module__5u2jiG__arrow",
  "check": "styles-module__5u2jiG__check",
  "icon": "styles-module__5u2jiG__icon",
  "list": "styles-module__5u2jiG__list",
  "menu": "styles-module__5u2jiG__menu",
  "option": "styles-module__5u2jiG__option",
  "root": "styles-module__5u2jiG__root",
  "trigger": "styles-module__5u2jiG__trigger",
});
